var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getAllMeasurements from "../../requests/metrics/getAllMeasurements";
/**
 *
 */
var GetAllMeasurementsCommand = /** @class */ (function (_super) {
    __extends(GetAllMeasurementsCommand, _super);
    function GetAllMeasurementsCommand() {
        return _super.call(this) || this;
    }
    /**
     * @param organisation OrganisationModel
     * @param measurementCollection MeasurementCollection
     * @return {*}
     */
    GetAllMeasurementsCommand.prototype.execute = function (organisation, measurementCollection) {
        this.measurementCollection = measurementCollection;
        var promise = getAllMeasurements(organisation, []);
        promise.then(this.then);
        return promise;
    };
    GetAllMeasurementsCommand.prototype.then = function (response) {
        this.measurementCollection.reset(true);
        this.measurementCollection.addAll(Object.values(response));
    };
    return GetAllMeasurementsCommand;
}(Command));
export default GetAllMeasurementsCommand;
